/* =========================================================================
   Harold Speelhuisjes — offerte.js
   Verantwoordelijk voor de complete offerte-flow:
   1. PRODUCTPAGINA (speelhuisje) : klik "Offerte samenstellen" -> onthoud het
      model in localStorage en ga naar de configurator.
   2. PRODUCTPAGINA (accessoire)  : klik "Zet in mijn offerte" -> onthoud de
      accessoire en ga direct naar de configurator. Accessoires zijn ook LOS
      te bestellen, dus er wordt NIET meer eerst een model afgedwongen.
      De gekozen uitvoering (data-variant-id) gaat mee en staat in de
      configurator vooraf gekozen (sinds 10-2026).
   3. CONFIGURATOR (/pages/offerte-samenstellen) : toon het model (optioneel),
      alle accessoires, live totaal en het offerteformulier. Bij verzenden
      bouwt dit script de payload en POST't naar de n8n-webhook.

   MEERTALIG (sinds 09-2026):
   - Alle interne paden lopen via rootUrl(): op /de/ en /en/ blijft de
     bezoeker in zijn eigen taal (configurator, modellenpagina, product-JSON,
     bedankpagina).
   - Alle zichtbare teksten komen uit het JSON-eiland #offerte-strings, dat
     de sectie vult met de locale-bestanden (hsh.js.*). Vertalen gebeurt dus
     in locales/*.json of in Translate & Adapt, niet hier.
   - Accessoires worden herkend op HANDLE (die is in elke taal gelijk), niet
     op woorden in de titel. Vertaal producthandles daarom NIET.
   - De payload bevat locale (nl/de/en) en klant.land (NL/BE/DE) zodat n8n de
     juiste taalvariant en het juiste transporttarief kan kiezen.

   LEAD-GARANTIE: mislukt de POST (workflow als draft = 404, executielimiet =
   429, CORS niet op *), dan valt dit script terug op het native Shopify-
   contactformulier in de sectie. De aanvraag komt dan alsnog per e-mail
   binnen. Er gaat dus nooit een lead verloren door een n8n-storing.

   ADVIES (sinds 10-2026): wie nog geen model weet, kiest in de configurator
   "Weet ik nog niet, ik wil graag advies". Het model gaat dan als object mee
   met title "Advies gewenst", variantTitle "" en price 0, plus
   advies_gewenst: true op het hoogste niveau. Nooit null voor deze keuze.
   Zonder accessoires is totaal 0; n8n accepteert dat dankzij advies_gewenst.

   GEEN STILLE BLOKKADES: een gevuld anti-spamveld of een verzending binnen
   3 seconden wordt niet meer weggegooid, maar via het Shopify-
   contactformulier (met Shopify's spamfilter) als e-mail verstuurd. Zo gaat
   er geen echte aanvraag verloren als autofill het anti-spamveld vult.

   VARIANTEN (sinds 10-2026): heeft het gekozen model meer dan een
   uitvoering (bijv. geen raam, raam of uitkijkluik), dan toont de modelbox
   die keuzes als knoppen. Een wissel past prijs, totaal en de opgeslagen
   keuze direct aan. Naar n8n gaat het model zonder de variantenlijst.

   BEDRAGEN: alles rekent in CENTEN (zoals Shopify ze levert). Alleen de
   conversiewaarde in sessionStorage wordt naar euro's omgerekend.

   Geen afhankelijkheden. Vanilla JS.
   ========================================================================= */
(function () {
  'use strict';

  var KEY_MODEL  = 'harold_offerte_model';        // { handle, variantId }
  var KEY_ACC    = 'harold_offerte_accessoires';  // { handle: true, ... }
  // sessionStorage (alleen dit tabblad): { acc: { handle: { variantId, naam, naamLater } }, form: { veld: waarde } }
  var KEY_KEUZES = 'harold_offerte_keuzes';

  // Adviesroute. ADVIES_KEY staat in localStorage als handle, zodat de keuze
  // een refresh overleeft. De titel is bewust NIET vertaald: n8n herkent hem
  // zo in elke taal. De bezoeker ziet het vertaalde label uit STR.
  var ADVIES_KEY   = '__advies__';
  var ADVIES_TITLE = 'Advies gewenst';
  function adviesModel() {
    return { handle: '', title: ADVIES_TITLE, variantId: null, variantTitle: '', price: 0, image: '' };
  }

  // Verzendt de POST niet binnen deze tijd, dan valt het script terug op het
  // Shopify-contactformulier. Liever een dubbele aanvraag dan een verloren.
  var POST_TIMEOUT_MS = 15000;

  // Productie-webhook (n8n). Wordt gebruikt als de Theme-editor setting leeg is,
  // zodat de POST ook werkt op een thema waar de setting niet is ingevuld.
  var DEFAULT_ENDPOINT = 'https://jop.app.n8n.cloud/webhook/offerte-hsh-v2';
  var DEFAULT_SECRET   = 'HS-OFFERTE-2026';

  /* ---------- Taal en paden ---------- */
  // Shopify zet window.Shopify.routes.root ('/' of bijv. '/de/'). theme.liquid
  // zet daarnaast window.routes.root_url en window.routes.locale.
  function rootUrl() {
    var r = '';
    try {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) r = String(window.Shopify.routes.root);
      else if (window.routes && window.routes.root_url) r = String(window.routes.root_url);
    } catch (e) {}
    if (!r || r === '/') return '/';
    if (r.charAt(0) !== '/') r = '/' + r;
    if (r.charAt(r.length - 1) !== '/') r += '/';
    return r;
  }
  // Maakt een relatief pad taalbewust: loc('/pages/x') -> '/de/pages/x' op /de/.
  function loc(path) {
    var p = String(path || '');
    if (!p) return p;
    if (/^(https?:)?\/\//.test(p) || /^(mailto:|tel:|#)/.test(p)) return p;
    var root = rootUrl();
    if (root === '/') return p;
    var prefix = root.slice(0, -1);              // '/de'
    if (p === prefix || p.indexOf(prefix + '/') === 0) return p;
    if (p.charAt(0) !== '/') p = '/' + p;
    return prefix + p;
  }
  function currentLocale() {
    var l = '';
    try { l = (window.routes && window.routes.locale) || (window.Shopify && window.Shopify.locale) || document.documentElement.lang || ''; } catch (e) {}
    l = String(l || 'nl').toLowerCase().split('-')[0];
    return l || 'nl';
  }
  var LOCALE     = currentLocale();
  var CONFIG_URL = loc('/pages/offerte-samenstellen');
  var MODELS_URL = loc('/collections/speelhuisjes');

  /* ---------- Teksten ----------
     Nederlandse fallback voor het geval het JSON-eiland ontbreekt (bijv. een
     oudere versie van de sectie). De sectie levert de vertaalde set. */
  var STR = {
    featured_title: 'Aanbevolen aanvullingen',
    your_playhouse: 'Jouw speelhuisje',
    change_model: 'Ander model kiezen',
    from: 'vanaf',
    poa: 'Prijs op aanvraag',
    poa_short: 'op aanvraag',
    variant_label: 'Uitvoering',
    name_label: 'Welke naam of namen mogen op het bordje?',
    name_placeholder: 'Bijv. Sophie & Daan',
    name_later: 'Naam later doorgeven',
    name_later_value: '(later doorgeven)',
    name_prefix: 'naam',
    no_accessories: 'Nog geen accessoires beschikbaar.',
    other_group: 'Overige accessoires',
    remove: 'Verwijderen',
    summary_empty_model: 'Nog geen accessoires gekozen, je speelhuisje staat hierboven al klaar.',
    summary_empty: 'Nog niets gekozen. Kies hierboven een speelhuisje of vink accessoires aan.',
    summary_empty_advice: 'Nog geen accessoires gekozen. Dat kan ook later, samen met het advies.',
    summary_total: 'Totale prijsindicatie',
    error_choose: 'Kies eerst een speelhuisje, de optie ‘Weet ik nog niet’ of minstens één accessoire.',
    error_fields: 'Er ontbreekt nog iets. Vul de gemarkeerde velden in.',
    error_send: 'Je aanvraag is niet verstuurd. Probeer het nog een keer, of app Harold via de WhatsApp-link onder de knop.',
    dig_note: 'Let op: eventuele graafwerkzaamheden dienen vooraf uitgevoerd te worden en zijn niet inbegrepen.',
    choose_model_title: 'Welk speelhuisje wordt het?',
    choose_model_hint: 'Alleen accessoires aanvragen kan ook. Sla deze stap dan over en kies ze hieronder.',
    choose_model_more: 'Eerst de modellen rustig bekijken',
    your_choice: 'Jouw keuze',
    advice_option: 'Weet ik nog niet, ik wil graag advies',
    advice_option_text: 'Harold of Jop denkt met je mee',
    advice_text: 'Geen probleem. Harold of Jop kijkt met je mee welk model in jullie tuin past, en zet dat in je offerte.',
    advice_price: 'Prijs volgt na advies',
    advice_price_short: 'Volgt na advies',
    advice_summary: 'Advies over het juiste speelhuisje'
  };
  function loadStrings() {
    var el = document.getElementById('offerte-strings');
    if (!el) return;
    try {
      var d = JSON.parse(el.textContent) || {};
      // Liquid levert soms al ge-escapete tekst ('&amp;'). Eerst terug naar
      // gewone tekst, anders escapet escapeHtml() hem een tweede keer en ziet
      // de bezoeker 'Sophie &amp; Daan'. Bij het tonen wordt alles weer veilig escaped.
      var dec = document.createElement('textarea');
      Object.keys(d).forEach(function (k) {
        if (d[k] == null || d[k] === '') return;
        dec.innerHTML = String(d[k]);
        STR[k] = dec.value;
      });
    } catch (e) { console.warn('[Harold offerte] #offerte-strings onleesbaar, Nederlandse fallback actief.'); }
  }

  /* ---------- Hulpfuncties ---------- */
  var INTL_LOCALE = { nl: 'nl-NL', de: 'de-DE', en: 'en-GB' }[LOCALE] || 'nl-NL';
  function euro(cents) {
    var n = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(INTL_LOCALE, { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
    } catch (e) {
      return '\u20AC\u00A0' + n.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  }
  function read(key, fallback) {
    try { return JSON.parse(localStorage.getItem(key)) || fallback; }
    catch (e) { return fallback; }
  }
  function write(key, val) {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {}
  }
  function readSession() {
    try { return JSON.parse(sessionStorage.getItem(KEY_KEUZES)) || {}; }
    catch (e) { return {}; }
  }
  function writeSession(val) {
    try { sessionStorage.setItem(KEY_KEUZES, JSON.stringify(val)); } catch (e) {}
  }
  function handleFromPath() {
    var m = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
    return m ? m[1] : null;
  }
  /* Shopify-CDN-afbeelding op de breedte waarop hij getoond wordt. Werkt voor
     URL's uit image_url (met &width=) en uit /products/x.js (origineel). */
  function sizedImg(url, w) {
    if (!url) return '';
    var u = String(url).replace(/([?&])width=\d+(&|$)/, function (m, a, b) { return b ? a : ''; });
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  // Vierkant miniatuur van px bij px: 1x en 2x, vaste afmetingen tegen
  // verspringen, lui laden waar het plaatje niet direct in beeld hoeft.
  function thumbHtml(url, cls, px, alt, lazy) {
    var x1 = escapeAttr(sizedImg(url, px)), x2 = escapeAttr(sizedImg(url, px * 2));
    return '<img class="' + cls + '" src="' + x2 + '" srcset="' + x1 + ' 1x, ' + x2 + ' 2x"' +
      ' width="' + px + '" height="' + px + '" alt="' + escapeAttr(alt || '') + '"' +
      (lazy ? ' loading="lazy"' : '') + ' decoding="async">';
  }
  function getJSON(url) {
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* =======================================================================
     1. PRODUCTPAGINA — speelhuisje: "Offerte samenstellen"
     ======================================================================= */
  function initModelButton() {
    var onProduct = /\/products\//.test(window.location.pathname);
    var btn = document.querySelector('#OfferteSamenstellen, [data-offerte="model"]');
    // Fallback: op een productpagina is een link naar de configurator de
    // model-knop — ook als de id in main-product.liquid afwijkt. Nooit op een
    // accessoirepagina: daar zou de accessoire anders als model worden opgeslagen.
    var isAccessoirePage = !!document.querySelector('#KiesSpeelhuisje, [data-offerte="accessoire"]');
    if (!btn && onProduct && !isAccessoirePage) btn = document.querySelector('a[href*="/pages/offerte-samenstellen"]');
    if (!btn) {
      if (onProduct && !isAccessoirePage) console.warn('[Harold offerte] Geen "Offerte samenstellen"-knop gevonden op deze productpagina. Controleer id/href in main-product.liquid.');
      return;
    }

    // Onthoudt het model van deze pagina. De URL van de productpagina is de
    // betrouwbaarste bron voor de handle.
    function remember() {
      var handle = handleFromPath() || btn.getAttribute('data-model') || '';
      if (!handle) return '';
      write(KEY_MODEL, { handle: handle, variantId: String(btn.getAttribute('data-variant-id') || '') });
      return handle;
    }

    // Het model wordt al bij het bekijken van de pagina onthouden, zodat ELKE
    // route naar de configurator het meeneemt: de beleving-CTA, de sticky
    // knop, een accessoirepagina via de slider, of later de header.
    if (onProduct) {
      remember();
      // Variantwissel: main-product.liquid zet data-variant-id bij 'change' op
      // het productformulier; daarna opnieuw wegschrijven.
      document.addEventListener('change', function () { setTimeout(remember, 0); });
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      // Navigeer naar de eigen href (behoudt o.a. preview-context), anders CONFIG_URL.
      var dest = (btn.tagName === 'A' && btn.getAttribute('href')) ? loc(btn.getAttribute('href')) : CONFIG_URL;
      var handle = remember();
      if (!handle) console.warn('[Harold offerte] Kon geen product-handle bepalen; ga zonder model verder.');
      else console.info('[Harold offerte] Model opgeslagen:', handle, '| variant:', btn.getAttribute('data-variant-id') || '(eerste beschikbare)');
      window.location.href = dest;
    });
  }

  /* =======================================================================
     2. PRODUCTPAGINA — accessoire: "Zet in mijn offerte"
     ======================================================================= */
  function initAccessoireButton() {
    var btn = document.querySelector('#KiesSpeelhuisje, [data-offerte="accessoire"]');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var handle = btn.getAttribute('data-handle') || handleFromPath();
      if (handle) {
        var acc = read(KEY_ACC, {});
        // Onthoud deze accessoire met de gekozen uitvoering (sinds 10-2026).
        // hsh-product-b zet data-variant-id bij elke wissel. Oude waarden
        // (true) blijven werken: dan kiest de configurator de eerste uitvoering.
        acc[handle] = { variantId: String(btn.getAttribute('data-variant-id') || '') };
        write(KEY_ACC, acc);
      }
      // Accessoires zijn ook los te bestellen: altijd door naar de configurator.
      // Eigen href van de knop (behoudt o.a. preview-context), anders CONFIG_URL.
      var dest = (btn.tagName === 'A' && btn.getAttribute('href')) ? loc(btn.getAttribute('href')) : CONFIG_URL;
      window.location.href = dest;
    });
  }

  /* =======================================================================
     3. CONFIGURATOR
     ======================================================================= */
  function initConfigurator() {
    var root = document.getElementById('offerte-configurator');
    if (!root) return;
    loadStrings();
    injectVariantStyles();

    var els = {
      modelBox:   root.querySelector('[data-model-box]'),
      accGrid:    root.querySelector('[data-acc-grid]'),
      total:      root.querySelector('[data-total]'),
      stickyTotal:root.querySelector('[data-sticky-total]'),
      form:       root.querySelector('[data-offerte-form]'),
      error:      root.querySelector('[data-error]'),
      submitBtn:  root.querySelector('[data-submit]'),
      fallback:   root.querySelector('#ho-fallback-form')
    };

    var reduceMotion = false;
    try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    var SCROLL = reduceMotion ? 'auto' : 'smooth';

    /* Sticky-knop: scrollt naar het formulier. Geen inline onclick meer. */
    var stickyCta = root.querySelector('[data-sticky-cta]');
    if (stickyCta) stickyCta.addEventListener('click', function () {
      if (!els.form) return;
      els.form.scrollIntoView({ behavior: SCROLL });
      var n = els.form.querySelector('[name="naam"]');
      if (n) setTimeout(function () { n.focus({ preventScroll: true }); }, 400);
    });

    /* Sticky balk weg zodra het formulier in beeld is (2.4): anders staan er
       twee chocoladebruine knoppen onder elkaar en dekt de balk de
       privacytekst af. Zonder IntersectionObserver blijft de balk staan. */
    var sticky = root.querySelector('[data-sticky]');
    if (sticky && els.form && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var inBeeld = entries[0].isIntersecting;
        sticky.classList.toggle('is-verborgen', inBeeld);
        if (inBeeld) sticky.setAttribute('aria-hidden', 'true'); else sticky.removeAttribute('aria-hidden');
      }, { rootMargin: '0px 0px -80px 0px' }).observe(els.form);
    }

    var thankYou = loc(root.getAttribute('data-thankyou') || '/pages/bedankt-voor-je-aanvraag');

    // E-mailfallback net verzonden? Shopify stuurt terug met ?contact_posted=true.
    // Stuur de klant dan alsnog naar de bedankpagina voor een nette afronding.
    if (/[?&]contact_posted=true/.test(window.location.search)) {
      try {
        var _lid2 = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : ('hs-' + Date.now() + '-' + Math.round(Math.random() * 1e6));
        sessionStorage.setItem('hs_lead', JSON.stringify({ value: 0, currency: 'EUR', id: _lid2 }));
      } catch (e) {}
      // Pas nu is de aanvraag echt binnen; daarom wist submitFallback() de
      // keuzes niet zelf, maar gebeurt het hier.
      clearStorage();
      if (thankYou) { window.location.replace(thankYou); return; }
    }

    var endpoint = root.getAttribute('data-endpoint') || DEFAULT_ENDPOINT;
    var secret   = root.getAttribute('data-secret') || DEFAULT_SECRET;
    console.info('[Harold offerte] locale =', LOCALE, '| root =', rootUrl(), '| endpoint =', endpoint, '| secret =', secret ? 'gezet' : 'LEEG', '| thankYou =', thankYou);

    // Accessoire-data die Liquid in de data-island heeft gezet
    var accessoires = [];
    var island = document.getElementById('offerte-accessoires-data');
    if (island) { try { accessoires = JSON.parse(island.textContent) || []; } catch (e) {} }

    // De acht modellen voor de modelkiezer (data-island uit de sectie).
    var modellen = [];
    var mIsland = document.getElementById('offerte-modellen-data');
    if (mIsland) { try { modellen = JSON.parse(mIsland.textContent) || []; } catch (e) {} }

    /* --- CRO-configuratie uit de Theme editor-instellingen --- */
    function cfgText(id){ var el=document.getElementById(id); return el ? String(el.textContent||'').trim() : ''; }
    function cfgLines(id){ return cfgText(id).split(/\r?\n/).map(function(s){return s.trim();}).filter(Boolean); }
    var CFG = {
      featuredTitel: cfgText('offerte-featured-titel') || STR.featured_title,
      featured:  cfgLines('offerte-featured'),
      naamVeld:  cfgLines('offerte-naamvelden'),
      notities:  cfgLines('offerte-notities').map(function(l){ var p=l.split('|'); return { kw:(p[0]||'').trim(), msg:(p.slice(1).join('|')||'').trim() }; }).filter(function(x){ return x.kw && x.msg; })
    };
    // Matcht een accessoire tegen een configregel. Eerst op handle (die is in
    // elke taal gelijk), daarna pas op trefwoord in titel/type. Gebruik in de
    // Theme editor bij voorkeur handles, dan werkt het ook in het Duits en Engels.
    function accMatches(a, needle){
      if(!needle) return false;
      var n = String(needle).toLowerCase();
      var h = String(a.handle||'').toLowerCase();
      return h === n
          || h.indexOf(n) !== -1
          || String(a.title||'').toLowerCase().indexOf(n) !== -1
          || String(a.type||'').toLowerCase().indexOf(n) !== -1;
    }
    function isFeatured(a){ return CFG.featured.some(function(x){ return accMatches(a,x); }); }
    function wantsNaam(a){
      if (CFG.naamVeld.length) return CFG.naamVeld.some(function(x){ return accMatches(a,x); });
      return accMatches(a, 'naambord');
    }
    function noteFor(a){
      var h = String(a.handle||'').toLowerCase();
      var hay = (h + ' ' + String(a.title||'') + ' ' + String(a.type||'')).toLowerCase();
      // Alleen de Robinia-zandbak: die vereist voorbereidend graafwerk.
      if ((h.indexOf('zandbak') !== -1 && h.indexOf('robinia') !== -1) ||
          (hay.indexOf('zandbak') !== -1 && hay.indexOf('robinia') !== -1)) {
        return STR.dig_note;
      }
      var hit = CFG.notities.filter(function(x){ return accMatches(a, x.kw); })[0];
      return hit ? hit.msg : '';
    }
    // Echte keuze-varianten (meer dan 1). Enkel 'Default Title' telt niet als keuze.
    function realVariants(a){
      var vs = (a.variants||[]).filter(function(v){ return v && v.title; });
      if (vs.length <= 1) return [];
      return vs;
    }

    // selected[handle] = { acc, variantId, variantTitle, price, naam, naamLater }
    // advies = true als de bezoeker "Weet ik nog niet, ik wil graag advies" koos;
    // state.model is dan adviesModel() (nooit null voor deze keuze).
    var state = { model: null, advies: false, selected: {} };

    /* --- Gekozen model laden (optioneel: accessoires mogen ook los) ---
       LET OP: dit blok staat bewust in een functie die PAS ONDERAAN
       initConfigurator wordt aangeroepen (zie `laadModel();`). Zou het hier
       direct draaien, dan zouden de `return`s hieronder de rest van
       initConfigurator overslaan — inclusief de registratie van de
       submit-handler — en zou het formulier niets doen.
       Er is geen lege staat meer: zonder model toont de modelbox de kiezer,
       en het formulier is altijd zichtbaar. */
    function startConfigurator() {
      renderModel();
      renderAccessoires();
      prefillRemembered();
      herstelKeuzes();
      recalc();
    }

    function setModel(model, advies) {
      state.model = model;
      state.advies = !!advies;
    }

    /* --- Uitvoeringen van het model (raam, geen raam, uitkijkluik) --- */
    // Alleen echte keuzes: meer dan 1 variant en geen 'Default Title'.
    function modelVarianten(list) {
      var vs = (list || []).filter(function (v) { return v && v.id && v.title && v.title !== 'Default Title'; })
        .map(function (v) { return { id: Number(v.id) || null, title: String(v.title), price: Number(v.price) || 0 }; });
      return vs.length > 1 ? vs : [];
    }
    // Naam van de eerste optie. /products/x.js levert objecten, Liquid strings.
    function optionNaam(opts) {
      var o = opts && opts[0];
      var n = !o ? '' : (typeof o === 'string' ? o : (o.name || ''));
      return String(n).toLowerCase() === 'title' ? '' : String(n);
    }
    // Het data-eiland bevat per model alleen de eerste variant. Na een keuze
    // in de modelkiezer worden de overige uitvoeringen hier aangevuld.
    function laadVarianten(handle) {
      getJSON(rootUrl() + 'products/' + handle + '.js').then(function (p) {
        var m = state.model;
        if (!p || !m || state.advies || m.handle !== handle) return;
        m.option = optionNaam(p.options);
        m.variants = modelVarianten(p.variants);
        renderModel();
      });
    }
    function kiesModelVariant(id) {
      var m = state.model;
      if (!m || state.advies) return;
      var v = (m.variants || []).filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) return;
      m.variantId = v.id;
      m.variantTitle = v.title;
      m.price = v.price;
      write(KEY_MODEL, { handle: m.handle, variantId: String(v.id) });
      renderModel();
      recalc();
      // Focus terug op de gekozen knop, niet naar de kop van de modelbox.
      var b = els.modelBox && els.modelBox.querySelector('[data-model-variant="' + cssEscape(String(v.id)) + '"]');
      if (b) b.focus({ preventScroll: true });
    }
    function modelVariantHtml(m) {
      var vs = m.variants || [];
      if (vs.length <= 1) return '';
      var base = Math.min.apply(null, vs.map(function (v) { return v.price; }));
      var label = m.option || STR.variant_label;
      return '<div class="ho-mvar" role="group" aria-label="' + escapeAttr(label) + '">' +
          '<span class="ho-mvar__label">' + escapeHtml(label) + '</span>' +
          '<div class="ho-mvar__grid">' + vs.map(function (v) {
            var on = String(v.id) === String(m.variantId);
            var diff = v.price - base;
            return '<button type="button" class="ho-mvar__opt' + (on ? ' is-active' : '') + '" aria-pressed="' + (on ? 'true' : 'false') + '" data-model-variant="' + escapeAttr(String(v.id)) + '">' +
                '<span>' + escapeHtml(v.title) + '</span>' +
                (diff > 0 ? '<small>+ ' + euro(diff) + '</small>' : '') +
              '</button>';
          }).join('') + '</div>' +
        '</div>';
    }
    // Model zonder variantenlijst: n8n krijgt hetzelfde object als voorheen.
    function modelVoorPayload() {
      if (!state.model) return null;
      var c = {};
      Object.keys(state.model).forEach(function (k) { if (k !== 'variants' && k !== 'option') c[k] = state.model[k]; });
      return c;
    }

    function laadModel() {
      var stored = read(KEY_MODEL, null);
      console.info('[Harold offerte] Opgeslagen model:', stored, '| onthouden accessoires:', Object.keys(read(KEY_ACC, {})));

      if (!stored || !stored.handle) {
        setModel(null, false);
        startConfigurator();
        return;
      }
      if (stored.handle === ADVIES_KEY) {
        setModel(adviesModel(), true);
        startConfigurator();
        return;
      }

      // Met taalprefix ophalen: dan komt de vertaalde producttitel mee.
      getJSON(rootUrl() + 'products/' + stored.handle + '.js').then(function (p) {
        if (!p) {
          console.warn('[Harold offerte] Product niet gevonden via ' + rootUrl() + 'products/' + stored.handle + '.js — toon de modelkiezer.');
          setModel(null, false);
          startConfigurator();
          return;
        }
        var variant = null;
        if (stored.variantId) {
          variant = (p.variants || []).filter(function (v) { return String(v.id) === String(stored.variantId); })[0];
        }
        if (!variant) variant = (p.variants || [])[0] || {};
        setModel({
          handle: p.handle,
          title: p.title,
          variantId: Number(variant.id) || null,
          variantTitle: (variant.title && variant.title !== 'Default Title') ? variant.title : '',
          price: (typeof variant.price === 'number') ? variant.price : p.price,
          image: p.featured_image || (p.media && p.media[0] && p.media[0].preview_image && p.media[0].preview_image.src) || '',
          option: optionNaam(p.options),
          variants: modelVarianten(p.variants)
        }, false);
        startConfigurator();
      });
    }

    /* --- Keuze uit de modelkiezer ---
       Een model komt direct uit het data-eiland (geen extra request, werkt ook
       op een trage verbinding). Accessoirekeuzes blijven staan. */
    function kiesModel(handle) {
      var m = modellen.filter(function (x) { return x.handle === handle; })[0];
      if (!m) return;
      setModel({
        handle: m.handle,
        title: m.title,
        variantId: Number(m.variant_id) || null,
        variantTitle: (m.variant_title && m.variant_title !== 'Default Title') ? m.variant_title : '',
        price: Number(m.variant_price != null ? m.variant_price : m.price) || 0,
        image: m.image || '',
        option: '',
        variants: []
      }, false);
      write(KEY_MODEL, { handle: m.handle, variantId: String(m.variant_id || '') });
      afterModelChange();
      laadVarianten(m.handle);
    }
    function kiesAdvies() {
      setModel(adviesModel(), true);
      write(KEY_MODEL, { handle: ADVIES_KEY, variantId: '' });
      afterModelChange();
    }
    function wisModel() {
      setModel(null, false);
      try { localStorage.removeItem(KEY_MODEL); } catch (e) {}
      afterModelChange();
    }
    function afterModelChange() {
      renderModel();
      recalc();
      hideError();
      // Focus naar de nieuwe inhoud van de modelbox, zodat toetsenbord- en
      // schermlezergebruikers niet bovenaan de pagina belanden.
      var target = els.modelBox && els.modelBox.querySelector('[data-model-focus]');
      if (target) target.focus({ preventScroll: true });
    }

    /* --- Render: gekozen model, advieskeuze of de modelkiezer --- */
    function renderModel() {
      if (!els.modelBox) return;
      var m = state.model;
      if (m && state.advies) {
        els.modelBox.innerHTML =
          '<div class="ho-model">' +
            '<div class="ho-model__body">' +
              '<span class="ho-tag">' + escapeHtml(STR.your_choice) + '</span>' +
              '<h3 class="ho-model__title" tabindex="-1" data-model-focus>' + escapeHtml(STR.advice_option) + '</h3>' +
              '<p class="ho-model__variant">' + escapeHtml(STR.advice_text) + '</p>' +
              '<p class="ho-model__price">' + escapeHtml(STR.advice_price) + '</p>' +
              '<button type="button" class="ho-model__change" data-change-model>' + escapeHtml(STR.change_model) + '</button>' +
            '</div>' +
          '</div>';
      } else if (m) {
        els.modelBox.innerHTML =
          '<div class="ho-model">' +
            (m.image ? thumbHtml(m.image, 'ho-model__img', 96, m.title, false) : '') +
            '<div class="ho-model__body">' +
              '<span class="ho-tag">' + escapeHtml(STR.your_playhouse) + '</span>' +
              '<h3 class="ho-model__title" tabindex="-1" data-model-focus>' + escapeHtml(m.title) + '</h3>' +
              (m.variantTitle ? '<p class="ho-model__variant">' + escapeHtml(m.variantTitle) + '</p>' : '') +
              '<p class="ho-model__price">' + euro(m.price) + '</p>' +
              '<button type="button" class="ho-model__change" data-change-model>' + escapeHtml(STR.change_model) + '</button>' +
            '</div>' +
          '</div>' +
          modelVariantHtml(m);
      } else {
        els.modelBox.innerHTML = kiezerHtml();
      }
      bindModelBox();
    }

    function kiezerHtml() {
      var items = modellen.map(function (x) {
        var price = Number(x.price) || 0;
        return '<button type="button" class="ho-acc ho-pick__btn" data-pick="' + escapeAttr(x.handle) + '">' +
            (x.image ? thumbHtml(x.image, 'ho-acc__img', 60, '', true) : '<span class="ho-acc__img ho-acc__img--ph" aria-hidden="true"></span>') +
            '<span class="ho-acc__body">' +
              '<span class="ho-acc__title">' + escapeHtml(x.title) + '</span>' +
              '<span class="ho-acc__price">' + (price > 0 ? escapeHtml(STR.from) + ' ' + euro(price) : escapeHtml(STR.poa)) + '</span>' +
            '</span>' +
            '<span class="ho-acc__toggle" aria-hidden="true">+</span>' +
          '</button>';
      }).join('');
      var advies =
        '<button type="button" class="ho-acc ho-pick__btn" data-pick-advies>' +
          '<span class="ho-acc__img ho-acc__img--ph ho-pick__icon" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M9.6 9.4a2.5 2.5 0 1 1 3.4 2.4c-.6.3-1 .8-1 1.4v.6"/><path d="M12 16.9v.1"/></svg>' +
          '</span>' +
          '<span class="ho-acc__body">' +
            '<span class="ho-acc__title">' + escapeHtml(STR.advice_option) + '</span>' +
            '<span class="ho-acc__price">' + escapeHtml(STR.advice_option_text) + '</span>' +
          '</span>' +
          '<span class="ho-acc__toggle" aria-hidden="true">+</span>' +
        '</button>';
      return '<div class="ho-pick" role="group" aria-labelledby="ho-pick-h">' +
          '<h3 class="ho-acc-group__h" id="ho-pick-h" tabindex="-1" data-model-focus>' + escapeHtml(STR.choose_model_title) + '</h3>' +
          '<p class="ho-section__sub">' + escapeHtml(STR.choose_model_hint) + '</p>' +
          // Plek voor "Kies eerst een speelhuisje": direct onder de kop, zodat
          // de melding in beeld staat als validate() hiernaartoe scrolt.
          '<div class="ho-error ho-pick__error" data-pick-error role="alert" hidden></div>' +
          '<div class="ho-acc-grid">' + items + advies + '</div>' +
          '<a class="ho-model__change ho-pick__more" href="' + MODELS_URL + '">' + escapeHtml(STR.choose_model_more) + '</a>' +
        '</div>';
    }

    function bindModelBox() {
      els.modelBox.querySelectorAll('[data-pick]').forEach(function (b) {
        b.addEventListener('click', function () { kiesModel(b.getAttribute('data-pick')); });
      });
      els.modelBox.querySelectorAll('[data-model-variant]').forEach(function (b) {
        b.addEventListener('click', function () { kiesModelVariant(b.getAttribute('data-model-variant')); });
      });
      var adv = els.modelBox.querySelector('[data-pick-advies]');
      if (adv) adv.addEventListener('click', kiesAdvies);
      var change = els.modelBox.querySelector('[data-change-model]');
      if (change) change.addEventListener('click', wisModel);
    }

    /* --- Render: accessoires (gegroepeerd, met varianten/naam/notities) --- */
    function itemHtml(a) {
      var vs = realVariants(a);
      var firstV = vs[0] || (a.variants && a.variants[0]) || {};
      var priceLabel;
      if (vs.length) {
        var prices = vs.map(function (v) { return Number(v.price) || 0; });
        var min = Math.min.apply(null, prices);
        priceLabel = min > 0 ? (STR.from + ' ' + euro(min)) : STR.poa;
      } else {
        var p = Number(firstV.price != null ? firstV.price : a.price) || 0;
        priceLabel = p > 0 ? ((a.vanaf ? STR.from + ' ' : '') + euro(p)) : STR.poa;
      }
      var note = noteFor(a);
      var detail = '';
      // Unieke id per accessoire, zodat label en veld gekoppeld zijn.
      var uid = 'ho-' + String(a.handle || '').replace(/[^a-z0-9_-]/gi, '-');
      if (vs.length || wantsNaam(a)) {
        detail += '<div class="ho-acc__detail" data-detail hidden>';
        if (vs.length) {
          var optLabel = (a.option && String(a.option).toLowerCase() !== 'title') ? a.option : STR.variant_label;
          detail += '<label class="ho-acc__optlabel" for="' + uid + '-variant">' + escapeHtml(optLabel) + '</label>';
          detail += '<select class="ho-acc__variant" id="' + uid + '-variant" data-variant>';
          vs.forEach(function (v) {
            var vp = Number(v.price) || 0;
            detail += '<option value="' + v.id + '" data-price="' + vp + '" data-title="' + escapeAttr(v.title) + '">' + escapeHtml(v.title) + (vp > 0 ? ', ' + euro(vp) : ', ' + escapeHtml(STR.poa.toLowerCase())) + '</option>';
          });
          detail += '</select>';
        }
        if (wantsNaam(a)) {
          detail += '<label class="ho-acc__optlabel" for="' + uid + '-naam">' + escapeHtml(STR.name_label) + '</label>';
          detail += '<input type="text" class="ho-acc__naam" id="' + uid + '-naam" data-naam maxlength="80" placeholder="' + escapeAttr(STR.name_placeholder) + '">';
          detail += '<label class="ho-acc__later"><input type="checkbox" data-naam-later> ' + escapeHtml(STR.name_later) + '</label>';
        }
        detail += '</div>';
      }
      return '<div class="ho-acc-item" data-item="' + escapeAttr(a.handle) + '">' +
        '<label class="ho-acc" data-acc="' + escapeAttr(a.handle) + '">' +
          '<input type="checkbox" class="ho-acc__cb" value="' + escapeAttr(a.handle) + '">' +
          (a.image ? thumbHtml(a.image, 'ho-acc__img', 60, a.title, true) : '<span class="ho-acc__img ho-acc__img--ph"></span>') +
          '<span class="ho-acc__body">' +
            '<span class="ho-acc__title">' + escapeHtml(a.title) + '</span>' +
            '<span class="ho-acc__price" data-price-label>' + priceLabel + '</span>' +
            (note ? '<span class="ho-acc__note">\u26A0 ' + escapeHtml(note) + '</span>' : '') +
          '</span>' +
          '<span class="ho-acc__toggle" aria-hidden="true">+</span>' +
        '</label>' + detail +
      '</div>';
    }

    // Categorievolgorde (CRO): grote, visuele items eerst; personalisatie en
    // kleine accessoires achteraan. Trefwoorden worden gezocht in de HANDLE
    // (taalonafhankelijk) en daarna in het producttype.
    var RANK_KW = ['glijba', 'schommel', 'keuken', 'modder', 'stuur', 'verrekijk', 'telescoop', 'klim', 'tuimel', 'uitbreid', 'zandbak', 'trap', 'naambord', 'person', 'krijt', 'bel', 'luik'];
    function rankOf(s) {
      s = (s || '').toLowerCase();
      for (var i = 0; i < RANK_KW.length; i++) { if (s.indexOf(RANK_KW[i]) !== -1) return i; }
      return 500;
    }
    function groupRank(type, items) {
      var best = 500;
      (items || []).forEach(function (a) { best = Math.min(best, rankOf(a.handle)); });
      if (best === 500) best = rankOf(type);
      return best;
    }

    function groupBlock(title, items, cls) {
      return '<div class="ho-acc-group ' + cls + '">' +
        '<h3 class="ho-acc-group__h">' + escapeHtml(title) +
          ' <span class="ho-acc-group__n">' + items.length + '</span></h3>' +
        '<div class="ho-acc-grid">' + items.map(itemHtml).join('') + '</div>' +
      '</div>';
    }

    function renderAccessoires() {
      if (!els.accGrid) return;
      if (!accessoires.length) { els.accGrid.innerHTML = '<p class="ho-muted">' + escapeHtml(STR.no_accessories) + '</p>'; return; }

      var featured = accessoires.filter(isFeatured);
      var rest = accessoires.filter(function (a) { return !isFeatured(a); });

      var groups = {}, order = [];
      rest.forEach(function (a) {
        var t = (a.type && String(a.type).trim()) ? String(a.type).trim() : STR.other_group;
        if (!groups[t]) { groups[t] = []; order.push(t); }
        groups[t].push(a);
      });
      order.sort(function (a, b) {
        var d = groupRank(a, groups[a]) - groupRank(b, groups[b]);
        return d !== 0 ? d : a.localeCompare(b, INTL_LOCALE);
      });

      var html = '';
      if (featured.length) html += groupBlock(CFG.featuredTitel, featured, 'is-featured');
      html += order.map(function (t) { return groupBlock(t, groups[t], ''); }).join('');
      els.accGrid.innerHTML = html;

      bindAccessoires();
    }

    function bindAccessoires() {
      els.accGrid.querySelectorAll('.ho-acc-item').forEach(function (item) {
        var handle = item.getAttribute('data-item');
        var a = accessoires.filter(function (x) { return x.handle === handle; })[0];
        if (!a) return;
        var lab    = item.querySelector('.ho-acc');
        var cb     = item.querySelector('.ho-acc__cb');
        var detail = item.querySelector('[data-detail]');
        var vsel   = item.querySelector('[data-variant]');
        var naam   = item.querySelector('[data-naam]');
        var later  = item.querySelector('[data-naam-later]');
        var plabel = item.querySelector('[data-price-label]');

        function currentVariant() {
          if (vsel) {
            var opt = vsel.options[vsel.selectedIndex];
            return { id: Number(vsel.value) || null, title: opt.getAttribute('data-title') || '', price: Number(opt.getAttribute('data-price')) || 0 };
          }
          var v = realVariants(a)[0] || (a.variants && a.variants[0]) || {};
          return { id: Number(v.id) || null, title: (v.title && v.title !== 'Default Title') ? v.title : '', price: Number(v.price != null ? v.price : a.price) || 0 };
        }
        function sync() {
          var on = cb.checked;
          if (lab) lab.classList.toggle('is-selected', on);
          item.classList.toggle('is-selected', on);
          if (detail) detail.hidden = !on;
          if (!on) { delete state.selected[handle]; bewaarAcc(handle, null); recalc(); return; }
          // Een accessoire is ook een keuze: de melding bij de kiezer mag weg.
          var pe = els.modelBox && els.modelBox.querySelector('[data-pick-error]');
          if (pe) pe.hidden = true;
          var v = currentVariant();
          state.selected[handle] = {
            acc: a, variantId: v.id, variantTitle: v.title, price: v.price,
            naam: (later && later.checked) ? STR.name_later_value : (naam ? naam.value.trim() : ''),
            naamLater: later ? later.checked : false
          };
          bewaarAcc(handle, { variantId: v.id, naam: naam ? naam.value : '', naamLater: later ? later.checked : false });
          if (plabel) plabel.textContent = v.price > 0 ? ((a.vanaf && !vsel ? STR.from + ' ' : '') + euro(v.price)) : STR.poa;
          recalc();
        }
        cb.addEventListener('change', sync);
        if (vsel) vsel.addEventListener('change', sync);
        if (naam) naam.addEventListener('input', sync);
        if (later) later.addEventListener('change', function () {
          if (naam) { naam.disabled = later.checked; if (later.checked) naam.value = ''; }
          sync();
        });
      });
    }

    /* --- Keuzes bewaren (2.3) ---
       Accessoire, variant en naam op het bordje gaan per wijziging naar
       sessionStorage, zodat terug, verversen of een telefoontje tussendoor
       niets wist. Alleen dit tabblad; wordt gewist zodra de aanvraag binnen is. */
    function bewaarAcc(handle, waarde) {
      var k = readSession();
      k.acc = k.acc || {};
      if (waarde) k.acc[handle] = waarde; else delete k.acc[handle];
      writeSession(k);
      // Bewust uitgevinkt: ook niet meer voorvinken vanaf een accessoirepagina.
      if (!waarde) {
        var onthouden = read(KEY_ACC, {});
        if (onthouden[handle]) { delete onthouden[handle]; write(KEY_ACC, onthouden); }
      }
    }
    function herstelKeuzes() {
      var acc = readSession().acc || {};
      Object.keys(acc).forEach(function (h) {
        var item = els.accGrid && els.accGrid.querySelector('.ho-acc-item[data-item="' + cssEscape(h) + '"]');
        if (!item) return;
        var s = acc[h] || {};
        var cb = item.querySelector('.ho-acc__cb');
        var vsel = item.querySelector('[data-variant]');
        var naam = item.querySelector('[data-naam]');
        var later = item.querySelector('[data-naam-later]');
        if (vsel && s.variantId && vsel.querySelector('option[value="' + cssEscape(String(s.variantId)) + '"]')) vsel.value = String(s.variantId);
        if (later && s.naamLater) {
          later.checked = true;
          if (naam) { naam.value = ''; naam.disabled = true; }
        } else if (naam && s.naam) {
          naam.value = s.naam;
        }
        if (!cb) return;
        cb.checked = true;
        cb.dispatchEvent(new Event('change'));   // sync() leest variant en naam opnieuw in
      });
    }
    var FORM_VELDEN = ['naam', 'email', 'telefoon', 'postcode', 'plaats', 'land', 'straat', 'opmerkingen'];
    function bindFormBewaren() {
      if (!els.form) return;
      var opgeslagen = readSession().form || {};
      FORM_VELDEN.forEach(function (name) {
        var el = els.form.querySelector('[name="' + name + '"]');
        if (!el) return;
        var w = opgeslagen[name];
        if (w != null && w !== '' && (el.tagName === 'SELECT' || el.value === '')) el.value = w;
        function bewaar() {
          var k = readSession();
          k.form = k.form || {};
          k.form[name] = el.value;
          writeSession(k);
        }
        el.addEventListener('input', bewaar);
        el.addEventListener('change', bewaar);
      });
    }

    /* --- Onthouden accessoires (van accessoirepagina's) voorvinken --- */
    function prefillRemembered() {
      var remembered = read(KEY_ACC, {});
      Object.keys(remembered).forEach(function (h) {
        var cb = els.accGrid && els.accGrid.querySelector('.ho-acc__cb[value="' + cssEscape(h) + '"]');
        if (!cb || cb.checked) return;
        // Uitvoering van de accessoirepagina vooraf zetten; sync() leest hem in
        // en schrijft hem naar sessionStorage, zodat herstelKeuzes() hem niet
        // terugzet naar een oudere keuze.
        var r = remembered[h];
        var vid = (r && typeof r === 'object' && r.variantId) ? String(r.variantId) : '';
        var item = cb.closest('.ho-acc-item');
        var vsel = item && item.querySelector('[data-variant]');
        if (vid && vsel && vsel.querySelector('option[value="' + cssEscape(vid) + '"]')) vsel.value = vid;
        cb.checked = true;
        cb.dispatchEvent(new Event('change'));
      });
    }

    /* --- Totaal herberekenen ---
       €0-items ("Prijs op aanvraag") tellen NIET mee in de indicatie, maar
       blijven wel geselecteerd en gaan mee in de aanvraag naar Harold. */
    function recalc() {
      var total = state.model ? state.model.price : 0;
      var hasOpAanvraag = false;
      Object.keys(state.selected).forEach(function (h) {
        var p = Number(state.selected[h].price) || 0;
        if (p > 0) total += p; else hasOpAanvraag = true;
      });
      var txt = totalText(total, hasOpAanvraag);
      if (els.total)       els.total.textContent = txt;
      if (els.stickyTotal) els.stickyTotal.textContent = txt;
      renderSummary(total, txt);
      return total;
    }
    // Advies zonder accessoires: geen "€ 0,00" tonen, maar wat er wel klopt.
    // Korte variant, zodat hij in de sticky balk op één regel past.
    function totalText(total, hasOpAanvraag) {
      if (state.advies && total === 0 && !hasOpAanvraag) return STR.advice_price_short;
      return euro(total) + (hasOpAanvraag ? ' + ' + STR.poa_short : '');
    }

    /* --- Live overzicht van de samenstelling --- */
    function summaryRow(label, price, removable, handle, priceText) {
      var p = Number(price) || 0;
      return '<div class="ho-summary__row">' +
        '<span class="ho-summary__label">' + escapeHtml(label) + '</span>' +
        '<span class="ho-summary__price">' + (priceText ? escapeHtml(priceText) : (p > 0 ? euro(p) : escapeHtml(STR.poa_short))) + '</span>' +
        (removable ? '<button type="button" class="ho-summary__x" data-remove="' + escapeAttr(handle) + '" aria-label="' + escapeAttr(STR.remove) + '">\u00D7</button>' : '') +
      '</div>';
    }
    function renderSummary(total, totalTxt) {
      var box = root.querySelector('[data-summary]');
      if (!box) return;
      var rows = '';
      if (state.advies) {
        rows += summaryRow(STR.advice_summary, 0, false, '', STR.advice_price);
      } else if (state.model) {
        rows += summaryRow(state.model.title + (state.model.variantTitle ? ', ' + state.model.variantTitle : ''), state.model.price, false);
      }
      var keys = Object.keys(state.selected);
      keys.forEach(function (h) {
        var s = state.selected[h];
        var label = s.acc.title + (s.variantTitle ? ', ' + s.variantTitle : '') + (s.naam ? ' (' + STR.name_prefix + ': ' + s.naam + ')' : '');
        rows += summaryRow(label, s.price, true, h);
      });
      if (!keys.length) {
        rows += '<p class="ho-summary__empty ho-muted">' +
          escapeHtml(state.advies ? STR.summary_empty_advice : (state.model ? STR.summary_empty_model : STR.summary_empty)) +
          '</p>';
      }
      box.innerHTML = rows +
        '<div class="ho-summary__total"><span>' + escapeHtml(STR.summary_total) + '</span><b>' + escapeHtml(totalTxt || euro(total)) + '</b></div>';
      box.querySelectorAll('[data-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var h = btn.getAttribute('data-remove');
          var cb = els.accGrid && els.accGrid.querySelector('.ho-acc__cb[value="' + cssEscape(h) + '"]');
          if (cb) { cb.checked = false; cb.dispatchEvent(new Event('change')); }
        });
      });
    }

    /* --- Formulier verzenden --- */
    if (els.form) {
      els.form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!validate()) return;
        var total = recalc();

        var regels = [];
        if (state.model) regels.push({
          title: state.model.title + (state.model.variantTitle ? ' (' + state.model.variantTitle + ')' : ''),
          handle: state.model.handle,
          variant_id: state.model.variantId, price: state.model.price, quantity: 1
        });
        Object.keys(state.selected).forEach(function (h) {
          var s = state.selected[h];
          var line = {
            title: s.acc.title + (s.variantTitle ? ', ' + s.variantTitle : ''),
            handle: h,
            variant_id: s.variantId, price: s.price, quantity: 1
          };
          if (s.naam) line.opties = { naam_op_bordje: s.naam };
          regels.push(line);
        });

        // Tracking voor Meta CAPI en Google Ads. Het event_id moet hetzelfde zijn
        // als het id dat op de bedankpagina wordt gebruikt, anders telt Meta dubbel.
        var leadId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : ('hs-' + Date.now() + '-' + Math.round(Math.random() * 1e6));
        function leesCookie(naam) {
          var m = document.cookie.match(new RegExp('(^| )' + naam + '=([^;]+)'));
          return m ? decodeURIComponent(m[2]) : '';
        }

        var land = (field('land') || '').toUpperCase() || (LOCALE === 'de' ? 'DE' : 'NL');

        var payload = {
          secret: secret,
          bron: 'offerte-configurator',
          tijdstip: new Date().toISOString(),
          event_id: leadId,
          locale: LOCALE,                       // nl | de | en: taal van de aanvraag
          tracking: {
            fbp: leesCookie('_fbp'),
            fbc: leesCookie('_fbc'),
            ga_client_id: leesCookie('_ga'),
            page_url: window.location.href,
            user_agent: navigator.userAgent
          },
          totaal: total,                        // 0 bij alleen advies zonder accessoires
          model: modelVoorPayload(),            // bij advies: { title: 'Advies gewenst', variantTitle: '', price: 0, ... }
          accessoires: Object.keys(state.selected).map(function (h) {
            var s = state.selected[h];
            return { handle: h, title: s.acc.title, variant: s.variantTitle, variant_id: s.variantId, price: s.price, naam: s.naam };
          }),
          regels: regels,
          klant: (function () {
            var straat = field('straat'), postcode = field('postcode'), plaats = field('plaats');
            var locatie = [straat, [postcode, plaats].filter(Boolean).join(' '), land].filter(Boolean).join(', ');
            return {
              naam:        field('naam'),
              email:       field('email'),
              telefoon:    field('telefoon'),
              straat:      straat,
              postcode:    postcode,
              plaats:      plaats,
              land:        land,                 // NL | BE | DE (ISO-landcode)
              taal:        LOCALE,               // taal waarin de klant benaderd wil worden
              locatie:     locatie,
              timing:      field('timing'),
              opmerkingen: field('opmerkingen')
            };
          })()
        };

        // Adviesroute: n8n accepteert totaal 0 alleen met deze vlag.
        if (state.advies) payload.advies_gewenst = true;

        setLoading(true);

        // Anti-spamsignalen blokkeren niet meer stil. Verdachte verzendingen
        // gaan als e-mail via het Shopify-contactformulier (met Shopify's
        // eigen spamfilter), zodat een echte ouder nooit kwijtraakt.
        var signaal = spamSignaal();
        if (signaal) {
          console.warn('[Harold offerte] Anti-spamsignaal "' + signaal + '": verstuur via het Shopify-contactformulier.');
          submitFallback(payload);
          return;
        }

        if (endpoint) {
          console.info('[Harold offerte] POST ->', endpoint);
          // Time-out: hangt de verbinding (mobiel, slecht bereik), dan na
          // POST_TIMEOUT_MS alsnog via het contactformulier.
          var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
          var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, POST_TIMEOUT_MS) : null;
          fetch(endpoint, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-store',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            signal: ctrl ? ctrl.signal : undefined
          }).then(function (r) {
            if (timer) clearTimeout(timer);
            console.info('[Harold offerte] webhook status', r.status);
            if (!r.ok) throw new Error('HTTP ' + r.status);
            clearStorage();
            try {
              sessionStorage.setItem('hs_lead', JSON.stringify({ value: (Number(total) || 0) / 100, currency: 'EUR', id: leadId }));
            } catch (e) {}
            // GEEN dataLayer-push hier. layout/theme.liquid vuurt het event
            // 'offerte_aangevraagd' op de bedankpagina, op basis van hs_lead
            // hierboven. Een tweede push hier telt elke lead dubbel in Ads.
            window.location.href = thankYou;
          }).catch(function (err) {
            if (timer) clearTimeout(timer);
            console.error('[Harold offerte] POST mislukt:', err,
              '\n-> Mogelijke oorzaken: workflow staat als draft (404), n8n-executielimiet bereikt (429),',
              'of "Allowed Origins (CORS)" staat niet op * in de n8n Webhook-node.',
              '\n-> Val nu terug op het Shopify-contactformulier zodat de lead NIET verloren gaat.');
            submitFallback(payload);
          });
        } else {
          // FALLBACK: geen webhook ingesteld -> Shopify-contactformulier (e-mail)
          submitFallback(payload);
        }
      });
    }

    // De fallbackmail gaat naar Jop, dus die blijft Nederlands.
    function submitFallback(payload) {
      if (!els.fallback) {
        setLoading(false);
        showError(STR.error_send);
        return;
      }
      var lines = ['--- OFFERTE-AANVRAAG ---'];
      if (payload.advies_gewenst) lines.push('ADVIES GEWENST: de klant weet nog niet welk model en wil advies.');
      payload.regels.forEach(function (r) {
        var l = '- ' + r.title + '  ' + (Number(r.price) > 0 ? euro(r.price) : 'prijs op aanvraag');
        if (r.opties && r.opties.naam_op_bordje) l += '  [naam: ' + r.opties.naam_op_bordje + ']';
        lines.push(l);
      });
      lines.push('TOTAALINDICATIE: ' + euro(payload.totaal));
      lines.push('');
      lines.push('Naam: ' + payload.klant.naam);
      lines.push('E-mail: ' + payload.klant.email);
      lines.push('Telefoon: ' + payload.klant.telefoon);
      lines.push('Locatie: ' + payload.klant.locatie);
      lines.push('Land: ' + (payload.klant.land || '-'));
      lines.push('Taal: ' + (payload.locale || '-'));
      lines.push('Gewenste termijn: ' + (payload.klant.timing || '-'));
      lines.push('Opmerkingen: ' + (payload.klant.opmerkingen || '-'));

      setHidden('contact[naam]',  payload.klant.naam);
      setHidden('contact[email]', payload.klant.email);
      setHidden('contact[Telefoon]', payload.klant.telefoon);
      setHidden('contact[body]',  lines.join('\n'));
      // Opslag NIET wissen: pas na ?contact_posted=true is de aanvraag binnen
      // (zie bovenaan initConfigurator). Zo blijft de keuze bewaard als
      // Shopify eerst een spamcontrole toont en de ouder teruggaat.
      // Gebruik requestSubmit zodat Shopify's spambescherming (reCAPTCHA) haar
      // token kan toevoegen; .submit() slaat dat over -> "Missing CAPTCHA token".
      if (typeof els.fallback.requestSubmit === 'function') {
        els.fallback.requestSubmit();
      } else {
        var sb = els.fallback.querySelector('[type="submit"]');
        if (sb) sb.click(); else els.fallback.submit();
      }
    }

    /* --- Validatie & veldhelpers --- */
    function field(name) {
      var el = els.form.querySelector('[name="' + name + '"]');
      return el ? el.value.trim() : '';
    }
    var formGeopend = Date.now();
    var bezigMetVerzenden = false;

    // Verdacht gedrag: gevuld anti-spamveld (bots, soms autofill) of binnen
    // 3 seconden na het laden verstuurd. Geen blokkade, wel de e-mailroute.
    function spamSignaal() {
      if (field('hs_controle') !== '') return 'anti-spamveld gevuld';
      if (Date.now() - formGeopend < 3000) return 'binnen 3 seconden verstuurd';
      return '';
    }

    var VERPLICHT = ['naam', 'email', 'postcode', 'plaats'];
    function setFieldError(el, on) {
      el.classList.toggle('is-invalid', on);
      if (on) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid');
      var msg = document.getElementById(el.id + '-err');
      if (msg) msg.hidden = !on;
    }
    // Zodra iemand een gemarkeerd veld aanpast, verdwijnt de markering.
    VERPLICHT.forEach(function (name) {
      var el = els.form && els.form.querySelector('[name="' + name + '"]');
      if (el) el.addEventListener('input', function () { if (el.classList.contains('is-invalid')) setFieldError(el, false); });
    });

    function validate() {
      if (bezigMetVerzenden) return false;                    // dubbelklik -> dubbele lead
      if (!state.model && Object.keys(state.selected).length === 0) {
        showChooseError();
        return false;
      }
      var eerste = null;
      VERPLICHT.forEach(function (name) {
        var el = els.form.querySelector('[name="' + name + '"]');
        if (!el) return;
        var v = el.value.trim();
        var valid = v !== '';
        if (name === 'email') valid = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v);
        setFieldError(el, !valid);
        if (!valid && !eerste) eerste = el;
      });
      if (eerste) { showError(STR.error_fields, eerste); return false; }
      hideError();
      bezigMetVerzenden = true;
      return true;
    }
    function setHidden(name, val) {
      var el = els.fallback.querySelector('[name="' + name + '"]');
      if (el) el.value = val;
    }
    function setLoading(on) {
      if (!on) bezigMetVerzenden = false;   // mislukte poging mag opnieuw
      if (!els.submitBtn) return;
      els.submitBtn.disabled = on;
      els.submitBtn.classList.toggle('is-loading', on);
    }
    // Toont de melding en brengt het probleem in beeld: op mobiel staat de
    // melding anders boven het formulier, buiten beeld van de duim.
    function showError(msg, focusEl) {
      var box = els.error;
      if (box) { box.textContent = msg; box.hidden = false; }
      var target = focusEl || box;
      if (!target) return;
      target.scrollIntoView({ behavior: SCROLL, block: 'center' });
      if (focusEl && typeof focusEl.focus === 'function') focusEl.focus({ preventScroll: true });
    }
    // Niets gekozen: de melding hoort bij de modelkiezer bovenaan, niet in het
    // foutvak boven het formulier. Dat vak staat onderaan de pagina en viel
    // buiten beeld zodra de pagina naar de kiezer scrolde (testplan D3).
    function showChooseError() {
      var slot = els.modelBox && els.modelBox.querySelector('[data-pick-error]');
      if (!slot) {
        // Kiezer (nog) niet getekend, bijv. terwijl een opgeslagen model laadt.
        showError(STR.error_choose);
        return;
      }
      if (els.error) els.error.hidden = true;
      slot.textContent = STR.error_choose;
      slot.hidden = false;
      // De melding zelf in het midden: de kop staat er direct boven, dus ook
      // achter een vaste header blijven beide in beeld.
      slot.scrollIntoView({ behavior: SCROLL, block: 'center' });
      var kop = els.modelBox.querySelector('[data-model-focus]');
      if (kop) kop.focus({ preventScroll: true });
    }
    function hideError() {
      if (els.error) els.error.hidden = true;
      var slot = els.modelBox && els.modelBox.querySelector('[data-pick-error]');
      if (slot) slot.hidden = true;
    }
    function clearStorage() {
      try { localStorage.removeItem(KEY_MODEL); localStorage.removeItem(KEY_ACC); } catch (e) {}
      try { sessionStorage.removeItem(KEY_KEUZES); } catch (e) {}
    }

    /* Alles is nu gebonden (submit-handler, sticky-knop, helpers). Pas hier het
       model/de accessoires laden en renderen. */
    bindFormBewaren();
    laadModel();
  }

  /* ---------- Styling variantknoppen ----------
     Hier en niet in offerte.css, zodat alles voor deze functie in een bestand
     staat. Zelfde stijl als de keuzeknoppen op de productpagina. */
  function injectVariantStyles() {
    if (document.getElementById('ho-mvar-css')) return;
    var css =
      '.ho-mvar{margin-top:14px}' +
      '.ho-mvar__label{display:block;margin:0 0 8px;font-size:12px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:#7a6a5c}' +
      '.ho-mvar__grid{display:grid;grid-template-columns:1fr;gap:8px}' +
      '.ho-mvar__opt{display:flex;align-items:center;justify-content:space-between;gap:10px;width:100%;min-height:48px;margin:0;padding:10px 14px;border:1.5px solid #ddd3c8;border-radius:12px;background:#fff;color:#1a1a1a;font:inherit;font-size:15px;font-weight:600;line-height:1.25;text-align:left;cursor:pointer;transition:background-color .15s,border-color .15s,color .15s}' +
      '.ho-mvar__opt small{font-size:13px;font-weight:500;opacity:.75;white-space:nowrap}' +
      '.ho-mvar__opt:hover{border-color:#111}' +
      '.ho-mvar__opt.is-active{background:#111;border-color:#111;color:#fff}' +
      '.ho-mvar__opt:focus-visible{outline:3px solid #5b3a1e;outline-offset:2px}' +
      '@media (min-width:750px){.ho-mvar__grid{grid-template-columns:repeat(3,1fr)}}';
    var el = document.createElement('style');
    el.id = 'ho-mvar-css';
    el.textContent = css;
    document.head.appendChild(el);
  }

  /* ---------- Escapes ---------- */
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }
  function cssEscape(s) { return String(s).replace(/["\\]/g, '\\$&'); }

  /* ---------- Init ---------- */
  function boot() {
    window.HaroldOfferte = true; // marker: script is geladen
    console.info('[Harold offerte] geladen op', window.location.pathname, '| taal', LOCALE);
    initModelButton();
    initAccessoireButton();
    initConfigurator();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();